import { AnalyticsEvent } from '../Model/analytics.event';

/**
 * An abstract class representing a repository for handling analytics events.
 * Provides a contract for logging events with a method that must be implemented
 * by derived classes.
 *
 * Implementations of this class are responsible for persisting or processing
 * analytics events in a manner specific to the use case or platform.
 */
export abstract class EventRepository {
    abstract logEvent(event: AnalyticsEvent): Promise<void>;

    abstract setAnalyticsConsent(isGiven: boolean): Promise<void>;
}
